/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './picker/basicbatchpickerstore.js';
import './picker/batchpickerstore.js';
import './picker/datepickerstore.js';
import './picker/objecttypepickerstore.js';
import './picker/pickerstore.js';

/**
 * Grouping module used for including all store sub-modules.
 */
angular.module('sbsf.stores', [
  'stores.picker',
  'stores.picker.batch',
  'stores.picker.basicbatch',
  'stores.picker.date',
  'stores.picker.objecttype'
]);
